<app-header *ngIf="this.router.url != '/espera' && this.router.url != '/termino' && this.router.url != '/agradecimiento'"></app-header>
<router-outlet></router-outlet>